import React from 'react';
import {
  Form,
  OriNumberInput,
  RadioGroup,
  RadioItem,
} from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { isNumber } from 'src/tools/helper';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { last2Precision, last4Precision } from 'src/tools/regExp';
import css from './css.module.less';
const Item = Form.Item;
const ItemShouldUpdate = Form.ShouldUpdate;

export enum DiscountValueType {
  Free = 'Free',
  Percentage = 'Percentage',
  Reduction = 'Reduction',
}

const AtDiscountValue = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    currency,
    radioName,
    percentageName,
    reductionAmountName,
    options,
    getRadioName,
    disableEdit,
  } = props;
  const dic = {
    [DiscountValueType.Free]: (
      <div className={css.radioItemContainer}>
        <RadioItem value={DiscountValueType.Free} className={css.radioItem}>
          {getI18n('general.free')}
        </RadioItem>
      </div>
    ),
    [DiscountValueType.Percentage]: (
      <div className={css.radioItemContainer}>
        <RadioItem
          value={DiscountValueType.Percentage}
          className={css.radioItem}>
          {getI18n('general.percentageOff')}
        </RadioItem>
        <ItemShouldUpdate
          dependencies={[radioName]}
          childGenerate={({ getFieldValue }) => {
            const isDisplay =
              getFieldValue(getRadioName || radioName) ===
              DiscountValueType.Percentage;
            if (isDisplay) {
              return (
                <Item
                  className={css.numberInput}
                  name={percentageName}
                  rules={[
                    {
                      validator: async (x, value) => {
                        if (!isNumber(value)) {
                          return Promise.reject(
                            new Error(getI18n('general.pleasefillthisfield')),
                          );
                        }
                        if (value < 0) {
                          return Promise.reject(
                            new Error(
                              replaceI18nVariables(
                                getI18n('general.valueshouldbegreaterthan'),
                                0,
                              ),
                            ),
                          );
                        }
                        if (!last4Precision.test(value)) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'salesChannelDirectDiscount.discountValue.fourDecimal',
                              ),
                            ),
                          );
                        }
                      },
                    },
                  ]}>
                  <OriNumberInput
                    size='large'
                    suffix='%'
                    max={99}
                    disabled={disableEdit}
                  />
                </Item>
              );
            }
            return null;
          }}
        />
      </div>
    ),
    [DiscountValueType.Reduction]: (
      <div className={css.radioItemContainer}>
        <RadioItem
          value={DiscountValueType.Reduction}
          className={css.radioItem}>
          {getI18n('general.fixedReductionAmount')}
        </RadioItem>
        <ItemShouldUpdate
          dependencies={[radioName]}
          childGenerate={({ getFieldValue }) => {
            const isDisplay =
              getFieldValue(getRadioName || radioName) ===
              DiscountValueType.Reduction;
            if (isDisplay) {
              return (
                <Item
                  className={css.numberInput}
                  name={reductionAmountName}
                  rules={[
                    {
                      validator: async (x, value) => {
                        if (!isNumber(value)) {
                          return Promise.reject(
                            new Error(getI18n('general.pleasefillthisfield')),
                          );
                        }
                        if (value < 0) {
                          return Promise.reject(
                            new Error(
                              replaceI18nVariables(
                                getI18n('general.valueshouldbegreaterthan'),
                                0,
                              ),
                            ),
                          );
                        }
                        if (!last2Precision.test(value)) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'salesChannelDirectDiscount.discountValue.twoDecimal',
                              ),
                            ),
                          );
                        }
                      },
                    },
                  ]}>
                  <OriNumberInput
                    suffix={currency || 'HKD'}
                    size='large'
                    disabled={disableEdit}
                  />
                </Item>
              );
            }
            return null;
          }}
        />
      </div>
    ),
  };
  return (
    <React.Fragment>
      <Item name={radioName} rules={[{ required: true }]}>
        <RadioGroup className={css.radioGroup} disabled={disableEdit}>
          {(
            options || [
              DiscountValueType.Free,
              DiscountValueType.Percentage,
              DiscountValueType.Reduction,
            ]
          ).map((i) => {
            return <React.Fragment key={i}>{dic[i] || null}</React.Fragment>;
          })}
        </RadioGroup>
      </Item>
    </React.Fragment>
  );
};
export default AtDiscountValue;
